export default "__VITE_ASSET__CN4SgN6b__"